import { useSelector } from 'react-redux';
import { selectResource } from '../reducer';

export const useResource = () => useSelector(selectResource);
